import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Renderer2
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
} from "@angular/forms";
import { LazyLoadEvent, MenuItem } from "primeng/api";
import { QuestionService } from "src/app/manage/questionanswer/service/question.service";
import { UserContestService } from "src/app/services/usercontest.service";
import * as moment from "moment";
import { ContestService } from "src/app/services/contest.service";
import { environment } from "src/environments/environment";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { ConfirmationService, MessageService } from "primeng/api";
import { CustomValidators } from "ng2-validation";
import { AuthService } from "src/app/services/auth.service";
import { MustMatch } from "src/app/_helpers/must-match.validator";
import { RoleService } from "src/app/services/role.service";
import { HttpClient } from "@angular/common/http";
import { maxYearFunction } from "src/app/_helpers/utility";
import { HeaderComponent } from "../header/header.component";
import { CityService } from "src/app/manage/city/service/city.service";
import { UserService } from "src/app/services/user.service";
import { CountryService } from "src/app/manage/country/service/country.service";
import { StateService } from "src/app/manage/state/service/state.service";
import { WindowRefService } from "src/app/services/window-ref.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import { UserWalletService } from "src/app/services/userWallet.service";
import { BannerService } from "src/app/services/banner.service";
import { Subscription, timer } from "rxjs";
import { take } from "rxjs/operators";
import { query } from "@angular/animations";
import { GeoLocationService } from "src/app/services/geo-location.service";
interface Defualtshorting {
  name: string;
  code: string;
}
interface CashCoin {
  name: string;
}
interface PaidOrFree {
  name: string;
  code: string;
}
@Component({
  selector: "app-contest",
  templateUrl: "./contest.component.html",
  styleUrls: ["./contest.component.scss"],
  providers: [
    BannerService,
    HeaderComponent,
    MessageService,
    ConfirmationService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContestComponent implements OnInit {
  displaytournamentName: any;
  tournamentCategoryName: any;
  shorting: Defualtshorting[];
  cashORcoin: CashCoin[];
  mobilFilter: boolean = false;
  filterType: PaidOrFree[];
  type: PaidOrFree;
  priceStructurePopup: boolean = false;
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public cmsContent;
  public cmsContentData;
  public bannerList: any[];
  public webBannerImageList: any[] = [];
  public mobileBannerImageList: any[] = [];
  items: MenuItem[];
  public options;
  public loading: boolean;
  public errorMessage: string;
  public totalRecords = 0;
  public totalContestRecords = 0;
  public contestList: any[] = [];
  public oneContest: any[] = [];
  public checkedBoxes: any[] = [];
  public attemptedQuestions: any[] = [];
  public resultList: any[] = [];
  public currentIndex: number = 0;
  public selectedOption: any = null;
  public currentQuestion;
  public answerString;
  public showSubmitButton: boolean = false;
  public downloadFlg: boolean = false;
  public showResult: boolean = false;
  public isTermsAndConditionsSelected: boolean = false;
  public isDontShowAgainSelected: boolean = false;
  public totalMarks: number = 0;
  public questionMarksTotal: number = 0;
  public countDown: Subscription;
  public counter;
  public tick;
  pricerangeform: FormGroup;
  poolPricerangeform: FormGroup;

  public minvalue: any = null;
  public maxvalue: any = null;
  public minpoolPrice: any = null;
  public maxpoolPrice: any = null;
  public isContestAvailable: boolean = false;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: "1024px",
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1,
    },
  ];
  @ViewChild("prevButton") prevButton: ElementRef;
  @ViewChild("nextButton") nextButton: ElementRef;
  lazyLoadEvent: LazyLoadEvent;
  searchby: any;
  startDate: any;
  endDate: any;
  public pagination = environment.pagination;
  public comingSoonMsg = environment.comingSoonMsg;
  public mode = "";
  loggedInUser: any;
  isLoggedIn: boolean = false;
  loginRegisterModal: boolean = false;
  showMobileLoginOtpForm: boolean = false;
  signUpForm: FormGroup;
  loginForm: FormGroup;
  forgotPassForm: FormGroup;
  mobileLoginForm: FormGroup;
  balanceForm: FormGroup;
  addCashForm: FormGroup;
  submitted: boolean = false;
  loginFormSubmitted: boolean = false;
  genders;
  message;
  showMessage: boolean = false;
  selectedGender: any = null;
  userType;
  userData;
  isLoginFailed: boolean;
  roles;
  userRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  ipAddress;
  yearRange;
  minDateValue: Date;
  minYear = environment.minYear;
  showGenderError;

  public cityList: any[] = [];
  public selectedCityId;
  public selectedCityName;
  public mobileNumber;
  public showOtpForm: boolean = false;
  public successMessage;
  public activeIndex: number = 0;
  public showCategoryError: boolean = false;
  public letsPlayButtonDisabled: boolean = false;
  public addCoinModal: boolean = false;
  public totalAvailableCash;
  @ViewChild("ngOtpInput", { static: false }) ngOtpInput: any;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: "",
    inputStyles: {
      width: "50px",
      height: "50px",
    },
  };
  courttype: any;
  public shareurl;
  public courtTypeList = environment.courtTypeList;
  public otp: string;
  public showForgotPasswordForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public userCategories: any[] = [];
  public countrylist: any[] = [];
  public selectedCategory = undefined;
  public stateList: any[] = [];
  public countryName;
  public countryCode;
  public stateName;
  public stateCode;
  public isAcademy: boolean = false;
  public cityName;
  public cityCode;
  public selectedType = undefined;
  public tplCoin: Number;
  public tplCash: Number;
  public showBalanceModal: boolean = false;
  public showBalanceCoinsError: boolean = false;
  public showBalanceCashError: boolean = false;
  public showAddCashModal: boolean = false;
  public tplCashCoinArr: any = [];
  public entryCash;
  public entryCoins;
  public cashFormSubmitted: boolean = false;
  public balanceFormSubmitted: boolean = false;
  public cashBalance: number = 0;
  public coinBalance: number = 0;
  public showCashBalance: boolean = false;
  public showCoinBalance: boolean = false;
  public showCashError: boolean = false;
  public showContestDetailSection: boolean = false;
  public userId;
  public contestId: any;
  public showPaymentSelectionError: boolean = false;
  public contest;
  public termsAndConditionsCheck: boolean = false;
  public dontShowAgainCheck: boolean = false;
  public showTermsAndConditionError: boolean = false;
  public showDontShowAgainError: boolean = false;
  showThankyouModal: boolean;
  totalCash: any;
  totalCoins: any;
  public addCoinForm: FormGroup;
  public coinSubmitted;
  public userContestList: any = [];
  tournamentId: any;
  public slug;
  totalDeductedCash: any;
  totalDeductedCoin: any;
  totalAvailableCoins: number;
  contestListData: any = [];
  walletBalance: number;
  sortAscending: boolean;
  paidContest: boolean | string = "";
  userDetails: any;
  under18: boolean = false;
  poolCash: boolean = false;
  poolCashPriceSubmitted: boolean = false;
  poolCoinPriceSubmitted: boolean = false;
  entryFeeSubmitted: boolean = false;
  public contestMatchStatusArray = environment.contestMatchStatusArray;
  matchStatusValue: any;
  id: string;
  player1Name: string;
  tournamentName: any;
  matchDate: any;
  poolCoins: any;
  player2Name: any;
  twoToFour: boolean;
  totalEntries: boolean;
  fiveToSeven: boolean;
  sevenToTen: boolean;
  eightToTwelve: boolean;
  eightToTen: boolean;
  elevenToThirteen: boolean;
  pricePoolStructurePopup: boolean;
  fourteenToEighteen: boolean;
  nineteenToTwentySeven: boolean;
  twentyEightToThirtysix: boolean;
  twentyEightToThirtySix: boolean;
  ThirtySevenToFifty: boolean;
  thirtySevenToFifty: boolean;
  fiftyOne: boolean;
  fiftyOnePlus: boolean;
  thirteenToEighteen: boolean;
  welcomeLogin: boolean = false;
  pageNumberFirst: any;
  pageLimitFirst: number;
  showRuleList: boolean = false;
  cashOrCoinSelection: any = null;
  showMoneyBalance: boolean;
  showBalanceMoneyError: boolean;
  showAddMoneyModal: boolean = false;
  isContestVerified: boolean;
  isAbove18Check: any;
  isAndroid: boolean;
  isFullAndroid: boolean = false;
  isContestBanned: boolean = false;
  isPWAInstalled: boolean;
  // {'2-4':[{"1st":"100%"}]},
  // {'5-7':[{"1st":"65%"}, {"2nd":"35%"}]},
  // {'7-10':[{"1st":"50%"}, {"2nd":"30%"}, {"3rd":"20%"}]}

  //];
  constructor(
    private questionService: QuestionService,
    private bannerService: BannerService,
    private userContestService: UserContestService,
    private contestService: ContestService,
    private router: Router,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private http: HttpClient,
    private headerComponent: HeaderComponent,
    private cityService: CityService,
    private userService: UserService,
    private countryService: CountryService,
    private stateService: StateService,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private winRef: WindowRefService,
    private walletPaymentService: WalletpaymentService,
    private userWalletService: UserWalletService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private routePage:Router,
    private geoLocationService: GeoLocationService,
     private renderer: Renderer2
  ) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;
    if (bodyElement) {
      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];
      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);
      this.bodyClass = nextClass;
    }
  }
  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }
  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  ngOnInit(): void {
       this.renderer.addClass(document.body, 'contest-partner-page');
    const isPWAInstalled = (): boolean => {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator['standalone'] === true;
    };
    this.isPWAInstalled = isPWAInstalled();
    
    this.geoLocationService.isPaidContestBanned.subscribe((banned) => {
      this.isContestBanned = banned
      if(this.isContestBanned){
      this.loadContest(this.lazyLoadEvent, this.mode);}
    });
    this.route.queryParams.subscribe((query)=>{
      if(query['page']) {
        this.pageNumberFirst = query['page'];
      } else {
        this.pageNumberFirst = 1;
      }
      if(query['limit']) {
        this.pageLimitFirst = +query['limit'];
      } else {
        this.pageLimitFirst = 10;
      }
      if (query['fullAndroid']) {
        const fullAndroidCondition = (query['fullAndroid'] === 'true') ? true : false;
        localStorage.setItem('fullAndroid',JSON.stringify(fullAndroidCondition));
      }
    })
    const userAgent = window.navigator.userAgent.toLowerCase();
    this.isAndroid = userAgent.includes('android') ? true : false;
    this.isFullAndroid = JSON.parse(localStorage.getItem('fullAndroid'));
    this.roleService.setCurrentActiveRoute(this.routePage.url);
    this.shorting = [
      { name: "Sort by price: low to high", code: "lowToHigh" },
      { name: "Sort by price: high to low", code: "highToLow" },
    ];
    this.cashORcoin = [{ name: "Coins" }, { name: "Cash" }];
    let dontShowAgainCheck = localStorage.getItem("dontShowAgainCheck");
    if (dontShowAgainCheck === "true") {
      this.showContestDetailSection = false;
    }
    this.filterType = [
      { name: "All", code: "NY" },
      { name: "Paid", code: "RM" },
      { name: "Free", code: "NY" },
    ];
    this.pricerangeform = this.formBuilder.group(
      {
        minvalue: [null, [Validators.min(0), Validators.required]],
        maxvalue: [null, [Validators.min(0), Validators.required]],
      },
      { validator: this.validateMinMaxValues }
    );

    this.poolPricerangeform = this.formBuilder.group(
      {
        minvalue: [null, [Validators.min(0), Validators.required]],
        maxvalue: [null, [Validators.min(0), Validators.required]],
      },
      { validator: this.validateMinMaxValues }
    );

    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isContestVerified = this.loggedInUser.userdata.isContestVerified;
      this.isAbove18Check = this.loggedInUser.userdata.isAbove18;
      this.isLoggedIn = true;
      this.getUserContest();
      setTimeout(()=>{
        this.getUserDetails(this.userId);
      },700);
      if (this.loggedInUser.userdata.rolename == "academy") {
        this.isAcademy = true;
      } else {
        this.isAcademy = false;
      }
    } else {
      this.isAcademy = false;
      this.loadContest(this.lazyLoadEvent, this.mode);
    }
    this.items = [
      { routerLink: "/", label: "Home" },
      { label: "Club Leagues" },
    ];
    this.loginForm = this.formBuilder.group({
      email: [
        "",
        [Validators.required, Validators.email, CustomValidators.email],
      ],
      password: ["", [Validators.required, Validators.minLength(6)]],
    });
    this.balanceForm = this.formBuilder.group({});
    this.addCashForm = this.formBuilder.group({
      cash: [null, [Validators.required]],
    });
    this.addCoinForm = this.formBuilder.group({
      amount: ["", [Validators.required, CustomValidators.number]],
    });
    this.getBanner();
    this.userCategories.forEach((element) => {
      this.signUpForm.addControl(element.slug, new FormControl());
      if (element.slug == "player") {
        this.selectedCategory = element.slug;
        this.signUpForm.get(element.slug).setValue(element.status);
      }
    });
    this.forgotPassForm = new FormGroup({
      email: new FormControl("", [
        Validators.required,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}"),
      ]),
    });
    this.mobileLoginForm = this.formBuilder.group({
      mobileNumber: [
        null,
        [Validators.required, Validators.pattern("[0-9 ]{10}")],
      ],
    });
    this.genders = [
      { id: "1", name: "Male", code: "Male" },
      { id: "2", name: "Female", code: "Female" },
      { id: "3", name: "Other", code: "Other" },
    ];
    this.selectedGender = this.genders[0];
    this.getCountries();
  }
    ngOnDestroy() {
    this.renderer.removeClass(document.body, 'contest-partner-page');
  }
  validateMinMaxValues(formGroup: FormGroup) {
    const minvalue = formGroup.get("minvalue").value;
    const maxvalue = formGroup.get("maxvalue").value;

    if (minvalue !== null && maxvalue !== null && minvalue > maxvalue) {
      formGroup.get("minvalue").setErrors({ invalidRange: true });
      formGroup.get("maxvalue").setErrors({ invalidRange: true });
    } else if (minvalue !== null && maxvalue !== null && minvalue <= maxvalue) {
      formGroup.get("minvalue").setErrors(null);
      formGroup.get("maxvalue").setErrors(null);
    }
  }

  onDownloadMoneyContestApp() {
    const obj = {};
    this.contestService.addDownloadMoneyContestAppHitCount(obj).subscribe((data:any) => {
      console.log('data : ',data);
    }, error => {
      this.errorMessage = error.error.message;
    })
  }
 
  // convenience getter for easy access to form fields
  get f() {
    return this.signUpForm.controls;
  }
  get loginf() {
    return this.loginForm.controls;
  }
  get forgotPassValidation() {
    return this.forgotPassForm.controls;
  }
  get mobNumberFormValidation() {
    return this.mobileLoginForm.controls;
  }
  get cashFormValidation() {
    return this.addCashForm.controls;
  }
  get f1() {
    return this.addCoinForm.controls;
  }
  get poolPrice() {
    return this.poolPricerangeform.controls;
  }
  get entryFeeC() {
    return this.pricerangeform.controls;
  }

  getUserDetails(userId) {
    this.userService.getUserDetails(userId).subscribe((data) => {
      this.userDetails = data;
      if (this.userDetails.age < 18) {
        this.type = { name: "Free", code: "NY" };
        this.under18 = true;
        this.mode = "paidOrfree";
        this.paidContest = false;
        this.loadContest(this.lazyLoadEvent, this.mode);
      }
    });
  }
  getUserContest() {
    let query =
      "filterByDisable=false&filterByStatus=true&filterByUserId=" + this.userId;
    this.userContestService.getUserContestList(query).subscribe(
      (data) => {
        this.userContestList = data.data.items;
        this.loadContest(this.lazyLoadEvent, this.mode);
      },
      (err) => { }
    );
  }

  onClickpricerange() {
    this.entryFeeSubmitted = true;
    if (this.pricerangeform.invalid) {
      return;
    }
    this.minvalue = this.pricerangeform.value["minvalue"];
    this.maxvalue = this.pricerangeform.value["maxvalue"];
    this.mode = "pricerange";
    this.loadContest(this.lazyLoadEvent, this.mode);
  }
  onClickPoolCash() {
    this.poolCashPriceSubmitted = true;
    if (this.poolPricerangeform.invalid) {
      return;
    }
    this.minpoolPrice = null;
    this.maxpoolPrice = null;
    this.minpoolPrice = this.poolPricerangeform.value["minvalue"];
    this.maxpoolPrice = this.poolPricerangeform.value["maxvalue"];
    this.mode = "poolpricerange";
    this.loadContest(this.lazyLoadEvent, this.mode);
  }
  onClickPoolCoin() {
    this.poolCoinPriceSubmitted = true;
    if (this.poolPricerangeform.invalid) {
      return;
    }
    this.minpoolPrice = null;
    this.maxpoolPrice = null;
    this.minpoolPrice = this.poolPricerangeform.value["minvalue"];
    this.maxpoolPrice = this.poolPricerangeform.value["maxvalue"];
    this.mode = "poolpricerange";
    this.loadContest(this.lazyLoadEvent, this.mode);
  }
  onClickSort(event) {
    this.type = { name: "All", code: "NY" };
    if (event.value != null) {
      if (event?.value?.code == "highToLow") {
        this.sortAscending = false;
      } else if (event?.value?.code == "lowToHigh") {
        this.sortAscending = true;
      }
      this.mode = "sort";
    } else {
      this.mode = "";
    }
    this.loadContest(this.lazyLoadEvent, this.mode);
  }
  onClickCashCoin(event) {
    if (event.value != null) {
      if (event?.value?.name == "Cash") {
        this.poolCash = true;
      } else if (event?.value?.name == "Coins") {
        this.poolCash = false;
      }
      this.mode = "sort";
    } else {
      this.mode = "";
    }
  }
  onClickFreeOrPaid(event) {
    if (event.value != null) {
      if (event.value.name == "Paid") {
        this.paidContest = true;
        this.mode = "paidOrfree";
      } else if (event.value.name == "Free") {
        this.paidContest = false;
        this.mode = "paidOrfree";
      } else {
        this.paidContest = ""
        this.mode = "";
      }
    } else {
      this.paidContest = ""
      this.mode = "";
    }
    this.loadContest(this.lazyLoadEvent, this.mode);
  }
  clear(mode) {
    if (mode == "price") {
      this.pricerangeform.reset();
      // this.pricerangeform.get('minvalue').setErrors(null);
      // this.pricerangeform.get('maxvalue').setErrors(null);
      this.changeDetectorRef.detectChanges();
    }
    if (mode == "poolPrice") {
      this.poolPricerangeform.reset();
      this.cashOrCoinSelection = null;
    }
    this.mode = "";
    this.loadContest(this.lazyLoadEvent, this.mode);
  }
  loadContest(event: LazyLoadEvent, mode) {
    this.poolCashPriceSubmitted = false;
    this.poolCoinPriceSubmitted = false;
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "?filterByDisable=false&filterByStatus=true";
    if (this.isLoggedIn == true) {
      query += "&filterByUserId=" + this.userId;
      query += "&filterByUserIdCheck=true";
    }
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
      this.routePage.navigate([], {
        relativeTo: this.route,
        queryParams: { page: pagenumber,limit: rows },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }

    if (event === undefined) {
      pagenumber = this.pageNumberFirst;
      rows = this.pageLimitFirst;
    }

    if (this.userDetails?.age < 18) {
      this.type = { name: "Free", code: "NY" };
      this.under18 = true;
      this.mode = "paidOrfree";
      this.paidContest = false;
      // this.loadContest(this.lazyLoadEvent, this.mode);
    }
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    let date = new Date();
    query += "&filterByDateAndTime=" + moment(date).utc().format("YYYY-MM-DD");
    // query += "&filterByDateAndTime=" + moment(date).local().format("YYYY-MM-DD HH:mm");
    if (mode == "pricerange") {
      query +=
        "&filterByMinPrice=" +
        this.minvalue +
        "&filterByMaxPrice=" +
        this.maxvalue;
    }
    if (mode == "poolpricerange") {
      if (this.cashOrCoinSelection?.name === 'Cash') {
        query +=
          "&filterByPoolCash=true&filterByMinPoolPrice=" +
          this.minpoolPrice +
          "&filterByMaxPoolPrice=" +
          this.maxpoolPrice;
      }

      if (this.cashOrCoinSelection?.name === 'Coins') {
        query +=
          "&filterByPoolCoin=true&filterByMinPoolPrice=" +
          this.minpoolPrice +
          "&filterByMaxPoolPrice=" +
          this.maxpoolPrice;
      }
    }
    if (this.sortAscending) {
      if (this.sortAscending == true) {
        query += "&sortBy=entryFee&orderBy=ASC";
      } else if (this.sortAscending == false) {
        query += "&sortBy=entryFee&orderBy=DSC";
      }
    } else {
      query += "&sortBy=matchDate&orderBy=ASC";
    }
    if (this.paidContest !== "") {
      if (this.paidContest == true) {
        query += "&filterByPaidContest=true";
      } else {
        query += "&filterByFreeContest=true";
      }
    }
    if (this.matchStatusValue) {
      query += "&filterByMatchStatus=" + this.matchStatusValue;
    } else {
      query += "&filterByTournamentMatchStatus=inprogress,notstarted";
    }
    if (this.isAndroid && !this.isFullAndroid) {
      query += "&filterByIsAndroid=true";
    }
    console.log('Is paid contest banned:', this.isContestBanned);
    if (this.isContestBanned) {
      query += "&filterByIsContestBanned=true";
    }
    if (this.route.snapshot.params.contestId) {
      /* let query1 =
        "?filterByDisable=false&filterByStatus=true&filterByContestId=" +
        this.route.snapshot.params.contestId;
      this.contestService.getContestListWithoutAuth(query1).subscribe(
        (contestdata) => {
          this.loading = false;
          this.oneContest = contestdata.data.items; */

          ////
          this.contestService.getContestListWithoutAuth(query).subscribe(
            (restData) => {
              window.scroll(0, 0);
              this.totalContestRecords = restData.data.totalCount;

              this.loading = false;
              let data = restData.data.items.filter(
                (contest) => contest.id !== this.route.snapshot.params.contestId
              );
              let matchFinishedFilterData = restData.data.items.filter((contest) =>
                contest.tournamentMatchStatus !== 'finished'
              );
              if (this.mode == '') {
                // this.contestList = this.oneContest.concat(matchFinishedFilterData);
              }
              this.contestList = restData.data.items.filter((contest) =>
              contest.tournamentMatchStatus !== 'finished'
            );
              if (this.isLoggedIn == true) {
                this.userContestList.forEach((element) => {
                  this.contestList.forEach((contest) => {
                    let tmp = this.contestList.find(
                      (o) => o.value === element.courttype
                    );
                    if (tmp != undefined) {
                      element.court = tmp.label;
                    } else {
                      element.court = "";
                    }
                    //contest['isContestRegistrationComplete'] = false;
                    if (element.contestId == contest.id) {
                      let index = this.findIndexById(element.contestId, this.contestList);

                      if (index != -1) {
                        //  this.contestList.splice(index, 1);
                        contest.isContestRegistrationComplete =
                          element.isContestRegistrationComplete;
                        contest.userContestId = element.id;
                      }
                    }
                  });
                });
              }
              //let counter = 100;
              this.contestList.forEach((cElement) => {
                // cElement.player1Name = this.encodeStr(cElement.player1Name);
                // cElement.player2Name = this.encodeStr(cElement.player2Name);

                let startTime = moment(new Date());
                let end = moment(cElement.matchDate);
                let duration = moment.duration(end.diff(startTime));
                let hours = duration.asHours();
                let counter = Number(hours) * Number(3600);
                cElement["time"] = counter;
                // minute = Math.round(minute);
                cElement["timerInterval"] = setInterval(() => {
                  let seconds = cElement["time"];
                  let dayTime = 60 * 60 * 24;
                  let day = Math.floor(seconds / dayTime);
                  let remainingTime = seconds - dayTime * day;
                  let hoursTime = 60 * 60;
                  let hour = Math.floor(remainingTime / hoursTime);
                  remainingTime = remainingTime - hoursTime * hour;
                  let minTime = 60;
                  let minute = Math.floor(remainingTime / minTime);
                  remainingTime = remainingTime - minTime * minute;
                  let second = Math.floor(remainingTime);
                  cElement["time"]--;
                  if (day >= 0) {
                    if (day >= 2 && hour >= 0 && minute >= 0 && second >= 0) {
                      cElement["displayTime"] = day + " Days";
                    } else if (
                      day > 0 &&
                      hour >= 0 &&
                      minute >= 0 &&
                      second >= 0
                    ) {
                      cElement["displayTime"] =
                        day + " Days " + hour + " Hours";
                    } else if (
                      day <= 0 &&
                      hour > 0 &&
                      minute >= 0 &&
                      second >= 0
                    ) {
                      cElement["displayTime"] =
                        hour + " : " + minute + " : " + second + " Hrs";
                    } else if (
                      day <= 0 &&
                      hour == 0 &&
                      minute > 0 &&
                      second >= 0
                    ) {
                      cElement["displayTime"] =
                        minute + " : " + second + " Minutes";
                    } else if (
                      day <= 0 &&
                      hour == 0 &&
                      minute == 0 &&
                      second > 0
                    ) {
                      cElement["displayTime"] = second + " Seconds left";
                    } else if (
                      day <= 0 &&
                      hour <= 0 &&
                      minute <= 0 &&
                      second <= 0
                    ) {
                      cElement["displayTime"] = "Match Started";
                    }
                  }
                  this.changeDetectorRef.detectChanges();
                }, 1000);
                //counter = 200;
              });
              if (this.contestList.length === 0) {
                this.isContestAvailable = true;
              } else {
                let index = this.contestList.findIndex(item => item.id === this.route.snapshot.params.contestId);

                if (index !== -1 && index > 0) {
                  let contestData = this.contestList.splice(index, 1)[0];
                  this.contestList.unshift(contestData);
                }

                // this.contestList.sort((a, b) => moment(a['matchDate']).unix() - moment(b['matchDate']).unix());
                this.isContestAvailable = false;
              }
              this.changeDetectorRef.detectChanges();
              let totalContestRecordsCount = Number(this.totalContestRecords) - Number(this.contestList.length);
              this.totalContestRecords = Number(this.totalContestRecords) - Number(totalContestRecordsCount);
            },
            (err) => {
              this.errorMessage = err.error.message;
            }
          );
       /*  },
        (err) => {
          this.errorMessage = err.error.message;
        }
      ); */
    } else {
      this.contestService.getContestListWithoutAuth(query).subscribe(
        (data) => {
          window.scroll(0, 0);
          this.loading = false;
          this.contestList = data.data.items;
          this.totalContestRecords = data.data.totalCount;
          this.tournamentId = data.data.items;
          this.tournamentCategoryName = data.data.items;
          this.matchDate = data.data.items;
          this.tournamentName = data.data.items;
          this.player1Name = data.data.items;
          this.totalEntries = data.data.items;

          this.player2Name = data.data.items;

          this.poolCash = data.data.items;
          // this.contestList = data.data.items.filter((contest) =>
          //   contest.tournamentMatchStatus !== 'finished'
          // );

          // this.organizercontactnumber = data.organizercontactnumber;
          // this.whatsAppgrouplink = data.whatsAppgrouplink;
          // this.tournamentCategories = data.tournamentCategories;
          // this.regulations = data.regulations;
          // this.sponsor_logo = data.sponsor_logo;
          // this.startdate = data.startdate;
          // this.enddate = data.enddate;
          // this.tournamentCategoryName = data.tournamentCategoryName;
          // this.lastdateofwithdraw = data.lastdateofwithdraw;
          // this.address = data.address;
          this.contestList.forEach((element) => {
            const heading = "Hi,";
            var subheading;
            if(element.giveAway){              
              subheading =
              "I am inviting you to join the TPL Contest and "+'*'+element.giveAway+'*'+" in the match between " +
              element.player1Name +
              " and " +
              element.player2Name +
              " in the " +
              element.tournamentCategoryName +
              " " +
              element.tournamentName +
              " 2025 🎾";
            } else {
              subheading =
              "I am inviting you to join the TPL Contest between " +
              element.player1Name +
              " and " +
              element.player2Name +
              " in the " +
              element.tournamentCategoryName +
              " " +
              element.tournamentName +
              " 2025 🎾";
            }
            
            // const titleparagraph = 'We are thrilled to announce the ' + element.tournamentCategoryName + ' ' + element.tournamentName + ' Tennis Contest '  + ' happening on ' + moment(element.matchDate).format('*MMMM D, YYYY, h:mm a*') + '. 🏆 ';
            // const playername = 'Players : ' + element.player1Name + ' Vs ' + element.player2Name;
            const entryfees = 'Entry Fees : ' + element.entryFee;
            const Cashcoinprizepool = element.updatedPoolCash > 0 ? 'Cash' : 'Coins';
            const prizepool = '*Prize Pool 💰*: ' + `*${element.updatedPoolCash > 0 ? element.updatedPoolCash : element.updatedPoolCoins}*`;
            const Cashcoinentryfess = element.updatedPoolCash > 0 ? '*Cash*' : '*Coins*';
            const deadline = 'Deadline ⏰: ' + moment(element.matchDate).format('MMMM D, h:mm A');
            var prizeText; 
            if(element.giveAway){
              prizeText = '\n'+ '\n'+'*1st Prize: TPL COINS + ' + element.giveAway+"*";
            } else {
              prizeText = '';
            }
            // } else (element.contest.updatedPoolCash !== null && element.contest.updatedPoolCash > 0); {
            //   element.updatedPoolCash = false;
            // };
            // const Tend = '* Entry Fees: ' + element.entryFee;
            // const Wd = '*🕒 Withdrawal Date: ' + moment(this.lastdateofwithdraw).format('DD-MM-YYYY') + '*';
            // const location = '*📍 Location: ' + this.address + ", " + this.cityname + ", " + this.statename + ", " + this.zipcode + '*';
            // const bottommsg = "Whether you're a seasoned player or just starting out, this tournament is the perfect opportunity to showcase your skills and have a blast on the court. It's all about friendly competition and the love of the game! 🎾💥";
            // const heiglishheading = '*Contest Highlights:*';
            // const cat = 'Categories : [All categories Name]';
            // const currentPageLink = window.location.href;
            // const currentPageLink = environment.frontEnd.domain + '/contest';
            // const link = "Don't miss your chance to be part of the action! To register or learn more about *Contest*, Please visit : " + currentPageLink ;
            // const pagelink = '*' + currentPageLink;
            // const org = 'For inquiries, contact ' + element.tournamentCategoryName;
            const text = "*_Tap the link below to join the contest:_*";
            // const seeyou = 'See you on the courts!';
            // const phoneNumber = '1234567890'; // Replace with the recipient's phone number
            const siteIconUrl = (this.isFullAndroid) ? 'https://www.tplsport.com/contest?fullAndroid=true' : 'https://www.tplsport.com/contest/'; // Replace with your site's icon URL
            const messageText = 'Hurry Up! Convert your tennis skills into ' + (element.updatedPoolCash > 0 ? 'Cash' : 'Coins') + ' now!';
            // Construct the WhatsApp sharing URL
            const message = encodeURIComponent(heading + '\n' + '\n' + subheading + '\n' + '\n' + entryfees + ' ' + Cashcoinprizepool + '\n' + '\n' + prizepool
              + ' ' + Cashcoinentryfess + '\n' + '\n' + deadline + prizeText +  '\n' + '\n' + text + '\n' + siteIconUrl + '\n' + '\n' + messageText);
            element.shareurl = `https://api.whatsapp.com/send?text=${message}&image=${siteIconUrl}`;


            if (element.updatedPoolCoins > 0) {
              this.entryCash = Number(element.entryFee) / Number(10);
              this.entryCoins = element.entryFee;
            } else if (element.updatedPoolCash > 0) {
              this.entryCash = element.entryFee;
              this.entryCoins = Number(element.entryFee) * Number(10);
            }

            if (element.value == data.data.items.courttype) {
              this.courttype = element.label;
            }
          });

          if (this.isLoggedIn == true) {
            this.userContestList.forEach((element) => {
              this.contestList.forEach((contest) => {
                if (element.contestId == contest.id) {

                  let index = this.findIndexById(element.contestId, this.contestList);
                  if (index != -1) {
                    //  this.contestList.splice(index, 1);
                    contest.isContestRegistrationComplete = element.isContestRegistrationComplete;
                    contest.userContestId = element.id;
                  }
                }
              });
            });
          }
          //let counter = 100;
          this.contestList.forEach((cElement) => {
            // cElement.player1Name = this.encodeStr(cElement.player1Name);
            // cElement.player2Name = this.encodeStr(cElement.player2Name);

            let tournamentstr = cElement.tournamentName;
            if (cElement.tournamentName != undefined) {
              let tournamentarr = tournamentstr.split(",");
              if (tournamentarr.length > 0) {
                cElement.displaytournamentName = tournamentarr[0];
              } else {
                cElement.displaytournamentName = tournamentstr;
              }
            } else {
              cElement.displaytournamentName = tournamentstr;
            }

            let startTime = moment(new Date());
            let end = moment(cElement.matchDate);
            let duration = moment.duration(end.diff(startTime));
            let hours = duration.asHours();
            let counter = Number(hours) * Number(3600);
            cElement["time"] = counter;
            // minute = Math.round(minute);
            cElement["timerInterval"] = setInterval(() => {
              let seconds = cElement["time"];
              let dayTime = 60 * 60 * 24;
              let day = Math.floor(seconds / dayTime);
              let remainingTime = seconds - dayTime * day;
              let hoursTime = 60 * 60;
              let hour = Math.floor(remainingTime / hoursTime);
              remainingTime = remainingTime - hoursTime * hour;
              let minTime = 60;
              let minute = Math.floor(remainingTime / minTime);
              remainingTime = remainingTime - minTime * minute;
              let second = Math.floor(remainingTime);
              cElement["time"]--;
              if (day >= 0) {
                if (day >= 2 && hour >= 0 && minute >= 0 && second >= 0) {
                  cElement["displayTime"] = day + " Days";
                } else if (day > 0 && hour >= 0 && minute >= 0 && second >= 0) {
                  cElement["displayTime"] = day + " Days " + hour + " Hours";
                } else if (day <= 0 && hour > 0 && minute >= 0 && second >= 0) {
                  cElement["displayTime"] =
                    hour + " : " + minute + " : " + second + " Hrs";
                } else if (day <= 0 && hour == 0 && minute > 0 && second >= 0) {
                  cElement["displayTime"] =
                    minute + " : " + second + " Minutes";
                } else if (day <= 0 && hour == 0 && minute == 0 && second > 0) {
                  cElement["displayTime"] = second + " Seconds left";
                } else if (
                  day <= 0 &&
                  hour <= 0 &&
                  minute <= 0 &&
                  second <= 0
                ) {
                  cElement["displayTime"] = "Match Started";
                }
              }
              this.changeDetectorRef.detectChanges();
            }, 1000);
            //counter = 200;
            // if (cElement.tournamentMatchStatus === 'finished') {
            //   let index = this.findIndexById(cElement.id, this.contestList);
            //   if (index != -1) {
            //     this.contestList.splice(index, 1);
            //   }
            // }
          });
          if (this.contestList.length === 0) {
            this.isContestAvailable = true;
          } else {
            this.contestList.sort((a, b) => moment(a['matchDate']).unix() - moment(b['matchDate']).unix());
            this.isContestAvailable = false;
          }
          this.changeDetectorRef.detectChanges();
          //   let totalContestRecordsCount = Number(this.totalContestRecords) - Number(this.contestList.length);
          //   this.totalContestRecords = Number(this.totalContestRecords) - Number(totalContestRecordsCount);
        },
        (err) => {

          this.errorMessage = err.error.message;
        }
      );
    }
  }

  contestPlayerName(playerName) {
    playerName = (playerName.split('/').length !== 2) ? playerName : playerName.split('/')[0].split(' ')[0]+' & '+playerName.split('/')[1].split(' ')[1];
    return playerName;
  }
  
  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  getCountries() {
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).subscribe(
      (data) => {
        if (data.data.items.length > 0) {
          data.data.items.forEach((element) => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            };
            this.countrylist.push(countryObj);
          });
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getStates(event) {
    this.countryName = event.value.name;
    this.countryCode = event.value.iso2;
    let query =
      "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" +
      this.countryCode;
    this.stateService.getstateList(query).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach((element) => {
          let stateObj = {
            name: element.name,
            id: element.id,
          };
          this.stateList.push(stateObj);
        });
      }
    });
  }
  setState(event) {
    this.stateCode = event.value.id;
    this.stateName = event.value.name;
    this.getCities(this.stateCode);
  }
  getCities(stateId) {
    let query =
      "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" +
      stateId;
    this.cityService.getcityList(query).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach((element) => {
          let cityObj = {
            name: element.name,
            code: element.name,
          };
          this.cityList.push(cityObj);
        });
      }
    });
  }
  // onCitySelect(event) {
  //   this.cityCode = event.value.code;
  //   this.cityName = event.value.name;
  // }
  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.searchRoleDetails(querystring).subscribe(
      (data) => {
        this.userRoleId = data.data.items[0]["id"];
        this.permissions = data.data.items[0]["permissions"];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  findIndexByIdArray(name, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].rolename === name) {
        index = i;
        break;
      }
    }
    return index;
  }
  getRoleList() {
    let querystring = "filterByDisable=false&filterByStatus=true";
    let rolearray = [];
    this.roleService.getRoleList(querystring).subscribe(
      (data) => {
        let rolelist = data.data.items;
        rolelist.forEach((element) => {
          rolearray.push({
            roleid: element.id,
            rolename: element.user_role_name,
          });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onUserCategorySelect(userCategory, event) {
    this.selectedCategory = undefined;
    if (event.isTrusted) {
      this.selectedCategory = userCategory.slug;
      this.userCategories.forEach((element) => {
        let obj = {
          slug: element.slug,
          name: element.name,
          status: element.status,
        };
        if (this.selectedCategory == element.slug) {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: true };
          this.userCategories[index] = obj;
          this.signUpForm.get(element.slug).setValue(obj.status);
        } else {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: false };
          this.userCategories[index] = obj;
          //this.accountReportForm.get(element.name).setValue(reportObj);
        }
      });
    }
  }
  findIndexBySlug(slug, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].slug === slug) {
        index = i;
        break;
      }
    }
    return index;
  }
  onSubmit(): void {
    this.loginFormSubmitted = true;
    //stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const username = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.userType = "player";
    this.authService.login(username, password, this.userType, false).subscribe(
      (data) => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.loginRegisterModal = false;
        let currentUrl = "/contest";
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate([currentUrl]);
        //this.onClickJoin(this.contest);
      },
      (error) => {
        //throw Error();
        this.loginFormSubmitted = false;
        this.errorMessage =
          "Login failed: Please check your login credentials...! ";
        let currentUrl = "/sign-in";
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate([currentUrl]);
        this.isLoginFailed = true;
      }
    );
    //});
  }
  onSignupSubmit(): void {
    this.submitted = true;
    //stop here if form is invalid
    if (this.signUpForm.invalid) {
      return;
    }
    let userData = this.signUpForm.value;
    if (this.selectedGender == null) {
      this.showGenderError = true;
      return;
    }
    if (this.selectedCategory == undefined) {
      this.showCategoryError = true;
      return;
    }
    userData["gender"] = this.selectedGender;
    userData["citycode"] = this.selectedCityId;
    userData["cityname"] = this.selectedCityName;
    userData["role"] = this.selectedCategory;
    userData["userType"] = this.selectedCategory;
    this.mobileNumber = userData["mobileNumber"];
    delete userData["coach"];
    delete userData["player"];
    this.authService.playerSignup(userData).subscribe(
      (data) => {
        //this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Added', life: 6000 });
        // setTimeout(() => {
        this.showMessage = true;
        this.showOtpForm = true;
        this.submitted = false;
        //this.message = 'User Added';
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        this.signUpForm.reset();
        // this.userTypeError = false;
        //this.selectedGender = this.genders[0];
        //this.router.navigateByUrl("/sign-in");
        //}, 5000);
      },
      (err) => {
        this.showMessage = true;
        this.message = err.error.error;
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        //this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add User Failed', life: 6000 });
      }
    );
  }
  onOtpChange(otp) {
    this.otp = otp;
  }
  onClickOtpSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      otp: this.otp,
      mobileNumber: this.mobileNumber,
    };
    this.authService.verifyOtp(otpData).subscribe(
      (data) => {
        // setTimeout(() => {
        this.showMessage = true;
        this.signUpForm.reset();
        this.submitted = false;
        this.showOtpForm = false;
        this.showOtpErrors = false;
        this.activeIndex = Number(0);
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      },
      (err) => {
        this.showOtpErrorsMsg = true;
        this.otpErrorMessage = err.error.error;
        setTimeout(() => {
          this.showOtpErrorsMsg = false;
        }, 5000);
      }
    );
  }

  onClickForgotPassword() {
    this.showForgotPasswordForm = true;
    this.loginRegisterModal = false;
  }

  onForgotPassSubmit() {
    this.submitted = true;
    if (this.forgotPassForm.valid) {
      this.authService.requestPassword(this.forgotPassForm.value).subscribe(
        (res) => {
          if (res["errors"]) {
            this.errorMessage = res["errors"];
            this.successMessage = "";
          } else {
            this.successMessage = res;
            this.errorMessage = "";
          }
          this.showMessage = true;
          setTimeout(() => {
            this.submitted = false;
            this.forgotPassForm.reset();
            this.showMessage = false;
            this.successMessage = "";
          }, 2000);
        },
        (err) => {
          this.successMessage = "";
          this.showMessage = true;
          this.errorMessage = err.error.data.errors;
        }
      );
    }
  }
  onMobilePhoneSubmit(mode) {
    let mobileData;
    if (mode != "resend") {
      this.submitted = true;
      //stop here if form is invalid
      if (this.mobileLoginForm.invalid) {
        return;
      }
      mobileData = this.mobileLoginForm.value.mobileNumber;
      this.mobileNumber = mobileData;
    } else {
      mobileData = this.mobileNumber;
    }
    // this.authService.generateMobileOtp(mobileData).subscribe(
    //   res => {
    //     this.showMobileLoginOtpForm = true;
    //     this.showResendButton = false;
    //     this.timer(1);
    //   }, err => {
    //     this.showMobileFormErrors = true;
    //     this.mobileFormsErrors = err.error.error;
    //     setTimeout(() => {
    //       this.showMobileFormErrors = false;
    //     }, 2000);
    //     this.showMobileLoginOtpForm = false;
    //   });
    this.authService.generateMobileOtp(mobileData).subscribe(
      (res) => {
        this.showMobileLoginOtpForm = true;
        this.showResendButton = false;
        //this.timer(5);
        this.counter = 300;
        this.tick = 1000;
        this.otpTimer(this.counter, this.tick);
      },
      (err) => {
        this.showMobileFormErrors = true;
        this.mobileFormsErrors = err.error.error;
        setTimeout(() => {
          this.showMobileFormErrors = false;
        }, 5000);
        this.showMobileLoginOtpForm = false;
      }
    );
  }
  resendOtp() {
    let mode = "resend";
    this.onMobilePhoneSubmit(mode);
  }
  onClickOtpLoginSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      otp: this.otp,
      mobileNumber: this.mobileNumber,
    };
    this.authService.otpLogin(otpData).subscribe(
      (data) => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        let currentUrl = "/contest";
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate([currentUrl]);
      },
      (err) => {
        this.showOtpLoginErrors = true;
        this.otpLoginErrors = err.error.error;
        setTimeout(() => {
          this.showOtpLoginErrors = false;
        }, 2000);
      }
    );
  }
  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;
      this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(timer);
        this.showResendButton = true;
      }
    }, 1000);
  }

  otpTimer(counter, tick) {
    this.countDown = timer(0, this.tick)
      .pipe(take(this.counter))
      .subscribe(() => {
        --this.counter;
        if (this.counter == 0) {
          this.showResendButton = true;
          this.countDown.unsubscribe();
        }
      });
  }
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ("00" + minutes).slice(-2) +
      ":" +
      ("00" + Math.floor(value - minutes * 60)).slice(-2)
    );
  }
  onClickOtpback() {
    this.showMobileLoginOtpForm = false;
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.countDown.unsubscribe();
  }
  onForgotPassBack() {
    this.showForgotPasswordForm = false;
    this.loginRegisterModal = true;
  }
  onCloseShowContestDetailSection() {
    this.isTermsAndConditionsSelected = false;
    this.isDontShowAgainSelected = false;
  }

  onTermsAndConditionsSelect(event, contest) {
    if (event.checked) {
      this.termsAndConditionsCheck = true;
      this.showTermsAndConditionError = false;
      this.isTermsAndConditionsSelected = true;
    } else {
      this.termsAndConditionsCheck = false;
      this.isTermsAndConditionsSelected = false;
    }
  }
  onDontShowAgainSelect(event) {
    if (event.checked) {
      this.dontShowAgainCheck = true;
    } else {
      this.dontShowAgainCheck = false;
    }
  }
  async onClickSubmit() {
    if (this.termsAndConditionsCheck == false) {
      this.showTermsAndConditionError = true;
      return;
    }
    this.isTermsAndConditionsSelected = false;
    this.isDontShowAgainSelected = false;
    this.showContestDetailSection = false;
    if (this.dontShowAgainCheck === true) {
      localStorage.setItem("dontShowAgainCheck", "true");
      // this.showContestDetailSection = false;
    } else {
      localStorage.setItem("dontShowAgainCheck", "false");
      //this.showContestDetailSection = true;
    }

    if(this.contest?.updatedPoolCoins !== null && this.contest?.updatedPoolCoins > 0) {
      this.addContest(0,this.contest?.entryFee);
    } else {
      this.addContest(this.contest?.entryFee,0);
    }

    // let query = "?filterByDisable=false&filterByUserid=" + this.userId;
    // this.userWalletService.getUserWalletList(query).subscribe(
    //   (data) => {
    //     this.loading = false;
    //     this.totalCash = data.data.totalCash;
    //     this.totalDeductedCash = data.data.totalDeductedCash;
    //     this.tplCash = this.totalCash - this.totalDeductedCash;
    //     this.totalCash = data.data.totalCash;
    //     this.totalDeductedCash = data.data.totalDeductedCash;
    //     this.tplCash = this.totalCash - this.totalDeductedCash;
    //     this.totalCoins = data.data.totalCoins;
    //     this.totalDeductedCoin = data.data.totalDeductedCoin;
    //     this.tplCoin = this.totalCoins - this.totalDeductedCoin;
    //     // this.totalCash = data.data.totalCash;
    //     // this.totalCoins = data.data.totalCoins;
    //     // this.tplCash = this.totalCash;
    //     // this.tplCoin = this.totalCoins;
    //     this.tplCashCoinArr = [
    //       {
    //         slug: "contestCash",
    //         coinsOrCash: this.tplCash,
    //         name: 'Contest Cash',
    //         status: true
    //       },
    //       // {
    //       //   slug: "coins",
    //       //   coinsOrCash: this.tplCoin,
    //       //   name: "Coins",
    //       //   status: false,
    //       // },
    //     ];
    //     if (this.userDetails?.age < Number(18)) {
    //       this.tplCashCoinArr = [
    //         {
    //           slug: "coins",
    //           coinsOrCash: this.tplCoin,
    //           name: "Coins",
    //           status: true,
    //         },
    //       ];
    //     }
    //     this.tplCashCoinArr.forEach((element) => {
    //       this.balanceForm.addControl(element.slug, new FormControl());
    //     });
    //     this.showBalanceModal = true;
    //   },
    //   (err) => {
    //     this.errorMessage = err.error.message;
    //   }
    // );
  }

  async addContest(cash, coins) {
    let userContestData = {
      cash: cash,
      coins: coins,
      contestId: this.contestId,
      userId: this.userId,
      tournamentId: this.tournamentId,
      termsAndConditions: this.termsAndConditionsCheck,
      dontShowAgain: this.dontShowAgainCheck,
    };
    this.userContestService.addUserContest(userContestData).subscribe(
      (data) => {
        if(this.contest?.updatedPoolCoins !== null && this.contest?.updatedPoolCoins > 0) {
          window.localStorage.setItem('contest-details-thankyou-page-display',JSON.stringify(false));
          setTimeout(() => {
            let currentUrl = "/contest-details/" + this.contestId;
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = "reload";
            setTimeout(() => {
              this.router.navigate([currentUrl],{ queryParams: { tplCoins: true}});
            }, 200);
          }, 200);
          return;
        } 
    
        if(this.contest?.updatedPoolCash !== null && this.contest?.updatedPoolCash > 0) {
          window.localStorage.setItem('contest-details-thankyou-page-display',JSON.stringify(false));
          setTimeout(() => {
            let currentUrl = "/contest-details/" + this.contestId;
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = "reload";
            setTimeout(() => {
              this.router.navigate([currentUrl],{ queryParams: { tplCoins: false}});
            }, 200);
          }, 200);
          return;
        } 
      },
      (err) => { }
    );
  }
  
  onClickJoin(contest) {
    if (Object.keys(this.loggedInUser).length === 0) {
      this.routePage.navigate(['/']);
      return;
    }
    
    this.contest = contest;
    if (contest?.poolCash > 0 && contest?.poolCash !== null) {
      if (this.loggedInUser.userdata.isProfileComplete === false) {
        this.welcomeLogin = true;
        return;
      }
    } else {
      if (this.loggedInUser?.userdata?.isContestVerified === false) {
        this.welcomeLogin = true;
        return;
      }
    }
    this.contestListData = [];
    this.contestListData.push(contest);
    //this.showThankyouModal = false;
    this.showBalanceCoinsError = false;
    if (this.isLoggedIn == false) {
      this.loginRegisterModal = true;
    } else {
      let dontShowAgainCheck = localStorage.getItem("dontShowAgainCheck");
      if (dontShowAgainCheck === "true") {
        this.showContestDetailSection = false;
        this.termsAndConditionsCheck = true;
        this.onClickSubmit();
      } else {
        this.showContestDetailSection = true;
      }
      this.showTermsAndConditionError = false;
      this.contestId = contest.id;
      this.tournamentId = contest.tournamentId;
      if (contest.updatedPoolCoins > 0) {
        this.entryCash = Number(contest.entryFee) / Number(10);
        this.entryCoins = contest.entryFee;
      } else if (contest.updatedPoolCash > 0) {
        this.entryCash = contest.entryFee;
        this.entryCoins = Number(contest.entryFee) * Number(10);
      }
    }
  }

  hideWelcomeLoginDialog() {
    this.welcomeLogin = false;
  }

  onTplCashOrCoinSelect(tplCashOrCoin, event) {
    this.selectedType = tplCashOrCoin.slug;
    this.showBalanceCoinsError = false;
    this.showBalanceCashError = false;
    this.showPaymentSelectionError = undefined;
    if (this.selectedType == 'cash') {
      this.cashBalance = Number(this.tplCash) - Number(this.entryCash);
      this.showCashBalance = true;
      this.showCoinBalance = false;
      this.showMoneyBalance = false;
    }
    if (this.selectedType == "coins") {
      this.coinBalance = Number(this.tplCoin) - Number(this.entryCoins);
      this.showCashBalance = false;
      this.showCoinBalance = true;
      this.showMoneyBalance = false;
    }
    if (this.selectedType == "contestCash") {
      this.coinBalance = Number(this.tplCash) - Number(this.entryCash);
      this.showCashBalance = false;
      this.showCoinBalance = false;
      this.showMoneyBalance = true;
    }
    this.tplCashCoinArr.forEach((element) => {
      let obj = {
        slug: element.slug,
        name: element.name,
        coinsOrCash: element.coinsOrCash,
        status: element.status,
      };
      if (this.selectedType == element.slug) {
        const index = this.findIndexBySlug(element.slug, this.tplCashCoinArr);
        if (index != -1) {
          obj = {
            slug: element.slug,
            name: element.name,
            coinsOrCash: element.coinsOrCash,
            status: true,
          };
          this.tplCashCoinArr[index] = obj;
          this.balanceForm.get(element.slug).setValue(obj.status);
        }
      } else {
        const index = this.findIndexBySlug(element.slug, this.tplCashCoinArr);
        if (index != -1) {
          obj = {
            slug: element.slug,
            name: element.name,
            coinsOrCash: element.coinsOrCash,
            status: false,
          };
          this.tplCashCoinArr[index] = obj;
        }
      }
    });
    if (this.selectedType == "cash") {
      if (Number(this.entryCash) > Number(this.tplCash)) {
        this.showBalanceCashError = true;
        return;
      }
    } else {
      this.showBalanceCashError = false;
    }

    if (this.selectedType == "coins") {
      if (Number(this.entryCoins) > Number(this.tplCoin)) {
        this.showBalanceCoinsError = true;
        return;
      }
    } else {
      this.showBalanceCoinsError = false;
    }

    if (this.selectedType == "contestCash") {
      if (Number(this.entryCash) > Number(this.tplCash)) {
        this.showBalanceMoneyError = true;
        return;
      }
    } else {
      this.showBalanceMoneyError = false;
    }
  }
  onClickAddCash() {
    this.showBalanceModal = false;
    this.showAddCashModal = true;
  }
  convertCashToMoney() {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to join the contest by converting TPL Cash into TPL Money?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Convert',
      acceptIcon: 'pi pi-arrow-right-arrow-left',
      rejectLabel: 'Cancel',
      rejectIcon: 'pi pi-times',
      acceptButtonStyleClass: 'convertButton',
      accept: () => {
        this.showBalanceModal = false;
        this.showAddMoneyModal = true;
      },
      reject: () => {
        this.showAddMoneyModal = false;
        this.showBalanceModal = true;
      },
  });
  }
  onCashSubmit() {
    this.showBalanceModal = true;
    this.cashFormSubmitted = true;
    //stop here if form is invalid
    if (this.addCashForm.invalid) {
      return;
    }
    let cashData = this.addCashForm.value;
    let cash = cashData["cash"];
    cashData["userId"] = this.userId;
    if (Number(cash) < Number(100)) {
      this.showCashError = true;
      return;
    } else {
      this.showCashError = false;
    }
    let addCashData = this.addCashForm.value;
    addCashData["userId"] = this.userId;
    addCashData["amount"] = addCashData.cash;
    if (addCashData["amount"] > 0) {
      this.showAddCashModal = false;
      addCashData = JSON.stringify(addCashData, null, 4);
      const amt = addCashData["amount"];
      this.walletPaymentService
        .addWalletPayment(addCashData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Cash to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: "CASH",
              amount: this.addCashForm.value.amount,
            };
            //commented below code as verify will be done by webhook
            // call your backend api to verify payment signature & capture transaction
            // this.walletPaymentService.verifyWalletpayment(verifyPaymentData).subscribe(paymentdata => {
            //   //this.showThankyouModal = true;
            //   this.onClickSubmit()
            //   this.showCashBalance = false
            //   // window.location.reload(); //use because of issue with reload.
            //   // this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'Cash Added.', life: 6000 });
            //   // let currentUrl = this.router.url;
            //   // setTimeout(() => {
            //   //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            //   //     this.router.navigate([currentUrl]);
            //   //   });
            //   // }, 2000);
            // })
            this.onClickSubmit();
            this.showCashBalance = false;
            this.addCashForm.reset();
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }
  onClickLetsPlay() {
    this.balanceFormSubmitted = true;
    //stop here if form is invalid
    if (this.balanceForm.invalid) {
      return;
    }
    if (this.selectedType == undefined) {
      this.showPaymentSelectionError = true;
      return;
    }
    let cash = 0;
    let coins = 0;
    let amount = 0;
    let mode;
    if (this.selectedType == "cash") {
      if (Number(this.entryCash) > Number(this.tplCash)) {
        this.showBalanceCashError = true;
        return;
      }
      cash = this.entryCash;
      amount = cash;
      mode = "CASH";
    }
    if (this.selectedType == "contestCash") {
      if (Number(this.entryCash) > Number(this.tplCash)) {
        this.showBalanceMoneyError = true;
        return;
      }
      cash = this.entryCash;
      amount = cash;
      mode = "MONEY";
    }
    if (this.selectedType == "coins") {
      if (Number(this.entryCoins) > Number(this.tplCoin)) {
        this.showBalanceCoinsError = true;
        this.messageService.add({
          key: "toastmsg",
          severity: "error",
          summary: "Error",
          detail: "Coin balance is low.",
          life: 6000,
        });
        return;
      }
      coins = this.entryCoins;
      amount = coins;
      mode = "COINS";
    }
    let userWalletData = {
      contestId: this.contestId,
      //tournamentId: this.tournamentId,
      userId: this.userId,
      amount: amount,
      wallettype: mode,
      action: "SUBTRACT",
      status: true,
      description: "Contest Joined",
    };
    this.userWalletService.addUserWallet(userWalletData).subscribe(
      async (data) => {
        await this.addContest(cash, coins);
      },
      (err) => {
        this.messageService.add({
          key: "toastmsg",
          severity: "error",
          summary: "Error",
          detail: "Server error, please try again.",
          life: 6000,
        });
      }
    );
  }

  closeThankyou() {
    this.showThankyouModal = false;
    this.showBalanceModal = true;
    this.router.navigate(["/contest"]);
    //this.router.navigate(['/my-wallet']);
  }
  addCoin() {
    this.addCoinModal = true;
    // this.showBalanceModal = false;
  }
  onCoinSubmit() {
    this.coinSubmitted = true;
    if (this.addCoinForm.invalid) {
      return;
    }
    let addCoinData = this.addCoinForm.value;
    addCoinData["userId"] = this.userId;
    if (addCoinData["amount"] > 0) {
      this.addCoinModal = false;
      addCoinData = JSON.stringify(addCoinData, null, 4);
      this.walletPaymentService
        .addWalletPayment(addCoinData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCoinForm.value.amount * 10 * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Coins to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: "COINS",
              amount: this.addCoinForm.value.amount,
            };
            // call your backend api to verify payment signature & capture transaction
            this.walletPaymentService
              .verifyWalletpayment(verifyPaymentData)
              .subscribe((paymentdata) => {
                //this.showThankyouModal = true;
                this.onClickSubmit();
                this.showCoinBalance = false;
                this.showBalanceCoinsError = false;
                this.addCoinForm.reset();
                // let currentUrl = this.router.url;
                // window.location.reload();
                // this.router.navigateByUrl('/contest', { skipLocationChange: false }).then(() => {
                //   this.router.navigate([currentUrl]);
                // });
              });
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }
  coinClose() {
    this.coinSubmitted = false;
  }
  getBanner() {
    let query =
      "?filterByDisable=false&filterByStatus=true&filterBySlug=contest";
    this.bannerService.getbannerList(query).subscribe(
      (data) => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach((element) => {
          this.webBannerImageList = element.banner_image;
          this.mobileBannerImageList = element.mobile_banner_image;
        });
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  encodeStr(str: string): string {
    return str?.replace(/\//g, '<span class="class-slash">/</span>');
  }

  showPoolstructure() {
    this.priceStructurePopup = true;
    this.showContestDetailSection = false;
  }

  // this.pricePoolStructurePopup = true;
  // if (contest.totalEntries >= 2 && contest.totalEntries <= 4) {
  //   this.twoToFour = true;
  //   this.fiveToSeven = false;
  //   this.sevenToTen = false;
  //   this.eightToTwelve = false;
  //   this.thirteenToEighteen = false;
  //   this.nineteenToTwentySeven = false;
  //   this.twentyEightToThirtySix = false;
  //   this.thirtySevenToFifty = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 5 && contest.totalEntries <= 7) {
  //   this.fiveToSeven = true;
  //   this.twoToFour = false;
  //   this.sevenToTen = false;
  //   this.eightToTwelve = false;
  //   this.thirteenToEighteen = false;
  //   this.nineteenToTwentySeven = false;
  //   this.twentyEightToThirtySix = false;
  //   this.thirtySevenToFifty = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 7 && contest.totalEntries <= 10) {
  //   this.sevenToTen = true;
  //   this.fiveToSeven = false;
  //   this.twoToFour = false;
  //   this.eightToTwelve = false;
  //   this.thirteenToEighteen = false;
  //   this.nineteenToTwentySeven = false;
  //   this.twentyEightToThirtySix = false;
  //   this.thirtySevenToFifty = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 8 && contest.totalEntries <= 12) {
  //   this.eightToTwelve = true;
  //   this.sevenToTen = false;
  //   this.fiveToSeven = false;
  //   this.twoToFour = false;
  //   this.thirteenToEighteen = false;
  //   this.nineteenToTwentySeven = false;
  //   this.twentyEightToThirtySix = false;
  //   this.thirtySevenToFifty = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 13 && contest.totalEntries <= 18) {
  //   this.thirteenToEighteen = true;
  //   this.eightToTwelve = false;
  //   this.sevenToTen = false;
  //   this.fiveToSeven = false;
  //   this.twoToFour = false;
  //   this.nineteenToTwentySeven = false;
  //   this.twentyEightToThirtySix = false;
  //   this.thirtySevenToFifty = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 19 && contest.totalEntries <= 27) {
  //   this.nineteenToTwentySeven = true;
  //   this.thirteenToEighteen = false;
  //   this.eightToTwelve = false;
  //   this.sevenToTen = false;
  //   this.fiveToSeven = false;
  //   this.twoToFour = false;
  //   this.twentyEightToThirtySix = false;
  //   this.thirtySevenToFifty = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 28 && contest.totalEntries <= 36) {
  //   this.twentyEightToThirtySix = true;
  //   this.nineteenToTwentySeven = false;
  //   this.thirteenToEighteen = false;
  //   this.eightToTwelve = false;
  //   this.sevenToTen = false;
  //   this.fiveToSeven = false;
  //   this.twoToFour = false;
  //   this.thirtySevenToFifty = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 37 && contest.totalEntries <= 50) {
  //   this.thirtySevenToFifty = true;
  //   this.twentyEightToThirtySix = false;
  //   this.nineteenToTwentySeven = false;
  //   this.thirteenToEighteen = false;
  //   this.eightToTwelve = false;
  //   this.sevenToTen = false;
  //   this.fiveToSeven = false;
  //   this.twoToFour = false;
  //   this.fiftyOnePlus = false;
  // }
  // if (contest.totalEntries >= 51) {
  //   this.fiftyOnePlus = true;
  //   this.thirtySevenToFifty = false;
  //   this.twentyEightToThirtySix = false;
  //   this.nineteenToTwentySeven = false;
  //   this.thirteenToEighteen = false;
  //   this.eightToTwelve = false;
  //   this.sevenToTen = false;
  //   this.fiveToSeven = false;
  //   this.twoToFour = false;
  // }

  showRulelist() {
    this.showRuleList = true;
  }

  showPrizePoolNewstructure(contest) {
    this.pricePoolStructurePopup = true;
    if (contest.totalEntries >= 0 && contest.totalEntries <= 4) {
      this.twoToFour = true;
      this.fiveToSeven = false;
      this.sevenToTen = false;
      this.eightToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 5 && contest.totalEntries <= 7) {
      this.fiveToSeven = true;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.eightToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 8 && contest.totalEntries <= 10) {
      this.eightToTen = true;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 11 && contest.totalEntries <= 13) {
      this.elevenToThirteen = true;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 14 && contest.totalEntries <= 18) {
      this.fourteenToEighteen = true;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 19 && contest.totalEntries <= 27) {
      this.nineteenToTwentySeven = true;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 28 && contest.totalEntries <= 36) {
      this.twentyEightToThirtySix = true;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 37 && contest.totalEntries <= 50) {
      this.thirtySevenToFifty = true;
      this.twentyEightToThirtySix = false;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 51) {
      this.fiftyOnePlus = true;
      this.thirtySevenToFifty = false;
      this.twentyEightToThirtySix = false;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
    }
  }
  onClickLive(contest) {
    // this.router.navigate(['contest-match-stats/' + contest.matchId]);
    if (this.isLoggedIn == false) {
      this.loginRegisterModal = true;
    } else {
      this.router.navigateByUrl("/contest-leader-board/" + contest.id);
    }
  }
  onChangeContestStatus(event) {
    if (event.value === null) {
      this.matchStatusValue = "";
      this.mode = "";
    } else {
      this.matchStatusValue = event.value.value;
      this.mode = "matchStatus";
    }
    this.contestList = [];
    this.loadContest(this.lazyLoadEvent, this.mode);
  }
  onClickRejoin(contest) {
    window.localStorage.setItem('contest-details-thankyou-page-display',JSON.stringify(false));
    setTimeout(() => {
      let currentUrl = "/contest-details/" + contest.id;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      setTimeout(() => {
        if(contest?.updatedPoolCoins !== null && contest?.updatedPoolCoins > 0) {
          this.router.navigate([currentUrl],{ queryParams: { contestJoin: false, tplCoins: true, resumeContest: true }});
        } else {
          this.router.navigate([currentUrl],{ queryParams: { contestJoin: false, tplCoins: false, resumeContest: true }});
        }
      }, 200);
    }, 200);
    return;
  }
   showMobileFilter() {
      this.mobilFilter = true;
     }
}
